import { render, staticRenderFns } from "./UiTable.vue?vue&type=template&id=d07dba9e&scoped=true"
import script from "./UiTable.vue?vue&type=script&lang=js"
export * from "./UiTable.vue?vue&type=script&lang=js"
import style0 from "./UiTable.vue?vue&type=style&index=0&id=d07dba9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07dba9e",
  null
  
)

export default component.exports